import { render, staticRenderFns } from "./AppointmentBubble.vue?vue&type=template&id=5b3f766d"
import script from "./AppointmentBubble.vue?vue&type=script&lang=ts"
export * from "./AppointmentBubble.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports